import React from 'react'

function PurchaseHistory() {
  return (
    <div className='bg-richblack-900 h-[calc(100vh-3.5rem)]  text-white'>PurchaseHistory</div>
  )
}

export default PurchaseHistory;